import React, { useState, useEffect } from 'react'
import InputField from '../../../../CommonComponents/InputMUI'
import AlertUi from '../../../../Popups/SidePopup'
import Loader from '../../../../../../../presentationals/Loader/Loader.component'
import SelectField from '../../../../CommonComponents/SelectMUI'
import { useLocation } from 'react-router-dom'
import { sendNotification } from './CommActionCreator'
const receiverdataCommunity = [
    { code: 'LENDER', name: 'Lender' },
    { code: 'USER', name: 'User' },
]
const receiverdataLenders = [
    { code: 'COMMUNITY', name: 'Community' },
    { code: 'USER', name: 'User' },
]
const receiverdataAdmin = [
    { code: 'LENDER', name: 'Lender' },
    { code: 'COMMUNITY', name: 'Community' },
    { code: 'USER', name: 'User' },
]
const type = [
    { code: 'push', name: 'Push Notification' },
    { code: 'app', name: 'App Notification' }
]

const NotificationCommunication = ({ rowData, viewScreen, loginType }) => {
    const [alertPopupState, setalertPopupState] = useState(false)
    const [msg, setmsg] = useState()
    const [loaderState, setloaderState] = useState(false)
    const [validationMsg, setValidationmsg] = useState()
    const [sendTo, setSendTo] = useState('')

    const location = useLocation()

    const [objectData, setObjectData] = useState({
        notification: '',
        communityId: '',
        lenderId: '',
        userId: '',
        notificationType:''
    })

    const inputChange = (e, type) => {
        let changeObjectData = Object.assign({}, objectData)
        changeObjectData[type] = e.target.value
        setObjectData(changeObjectData)
        // setMessage({})
    }
    const removePopup = () => {
        setTimeout(
            function () {
                setalertPopupState(false)
            }.bind(this),
            5000
        );
    }

    const sendHandler = () => {
        setloaderState(true)
        let valid = validations(objectData)

        if (valid === "success") {
            setValidationmsg("")
            sendNotification(objectData, callBack => {
                if (callBack.message === "success") {
                    console.log(callBack);
                    setObjectData({
                        notification: '',
                        communityId: '',
                        lenderId: '',
                        userId: ''
                    })
                    setSendTo('')
                    setalertPopupState(true)
                    setmsg('Successfully sent!')
                    setValidationmsg("")
                    removePopup()
                }
                setloaderState(false)
            }, error => {
                setloaderState(false)
            })
        } else {
            setValidationmsg(valid)
            setloaderState(false)
        }

    }
    const validations = (objectData) => {
        if (sendTo === '' || sendTo === null) {
            return "Please Select Send To"
        }
        if (objectData.notificationType === '' || objectData.notificationType === null) {
            return "Please Select Type"
        }
        if (objectData.notification === '' || objectData.notification === null) {
            return "Please Enter Notification Body"
        }
        else {
            return "success"
        }
    }

    const sendToHandler = (e, type) => {
        console.log(objectData);
        if (type === 'sendTo') {
            setSendTo(e)
            setloaderState(true)
            if (e === "LENDER") {
                objectData.lenderId = rowData.lenderId
                objectData.communityId = ''
                objectData.userId = ''
            }
            else if (e === "COMMUNITY") {
                objectData.communityId = rowData.communityId
                objectData.lenderId = ''
                objectData.userId = ''
            }
            else if (e === "USER") {
                objectData.userId = rowData.userId
                objectData.communityId = ''
                objectData.lenderId = ''
            }
            setObjectData(objectData)
            setloaderState(false)
        }
        else if (type === "type") {
            objectData["notificationType"] = e
            setObjectData(objectData)
        }
    }

    return (
        <div className='container-fluid full-height'>
            {loaderState ?
                <Loader />
                : ""}
            {alertPopupState ?
                <AlertUi msg={msg} />
                : ""}
            <div className='row'>
                <div className='col-sm-4 col-xs-12'>
                    <SelectField
                        label={'Send To'}
                        onChange={e => sendToHandler(e, "sendTo")}
                        value={sendTo}
                        data={receiverdataAdmin}
                        size={'small'}
                        required={true}
                    />
                </div>
                <div className='col-sm-4 col-xs-12'>
                    <SelectField
                        label={'Type'}
                        onChange={e => sendToHandler(e, "type")}
                        value={objectData.notificationType}
                        data={type}
                        size={'small'}
                        required={true}
                    />
                </div>
            </div>


            <div className='row ' style={{marginTop:'14px'}}>
                <div className='col-sm-8 col-xs-12 mt-2'>

                    <textarea className='form-control form-group'
                        value={objectData.notification}
                        onChange={e => inputChange(e, "notification")}
                        placeholder="Enter notification here..."
                        style={{background:'#fff',minHeight: '150px',border:'1px solid #dee2e6'}}
                    >
                    </textarea>

                    <h5 className='text-danger text-center'>{validationMsg}</h5>
                    <div className='mb-3 row'>
                        <div className="col-12 text-center">
                            <button className="cred-btn" style={{fontSize:"16px"}} onClick={e => sendHandler()}>Send</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default NotificationCommunication;
